// interfaces
interface IProps {
  children: React.ReactNode;
  fullHeight?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const Box: React.FC<IProps> = ({ children, fullHeight, style, className }) => (
  <div
    className={`box ${className || ''}`}
    style={{ ...(fullHeight ? { height: '100%' } : {}), ...style }}
  >
    {children}
  </div>
);

export default Box;
